import { of } from 'rxjs';
import {
  UspDirection,
  CmsComponentData,
  UspComponentModel,
} from '@boels/models';

export const uspMockData: UspComponentModel = {
  content:
    '<ul><li>USP TEST</li><li>QA Test</li><li><a href="http://google.com" target="_blank">Hlink</a></li><li>Testing</li></ul>',
  direction: UspDirection.HORIZONTAL,
};

export const uspMockDataComponentData: CmsComponentData<UspComponentModel> = {
  data$: of(uspMockData),
};
